// joe-slider-nav.js
document.addEventListener('DOMContentLoaded', function() {
  // 获取所有的slider-nav section
  const sliderSections = document.querySelectorAll('.joe-slider-nav_container');

  
  sliderSections.forEach(sliderSection => {
    initSlider(sliderSection);
  });
  
  function initSlider(section) {
    // 获取该section的ID
    const sectionId = section.id.split('-').pop();
    
    // 获取轮播项和导航条
    const sliderItems = section.querySelectorAll('.joe-slider-nav_item');
    const navItems = section.querySelectorAll('.joe-slider-nav_li');
    const slidesContainer = section.querySelector('.joe-slider-nav_items');
    const sliderWrapper = section.querySelector('.joe-slider-nav_wrapper');
    
    if (!sliderItems.length || !navItems.length) return;
    
    // 配置参数
    const slideTime = 5000; // 每张幻灯片显示时间(毫秒)
    const progressUpdateInterval = 30; // 进度条更新间隔(毫秒)
    const resumeDelay = 5000; // 触摸结束后恢复自动播放的延迟(毫秒)
    
    let currentSlide = 0;
    let autoPlayTimer = null;
    let progressTimer = null;
    let progressValue = 0;
    let isAnimating = false;
    let isTouching = false;
    let resumeTimeout = null; // 用于跟踪恢复自动播放的计时器
    let savedProgressValue = 0; // 保存暂停时的进度值
    
    // 获取items之间的gap
    const itemGap = getItemGap();
    
    // 计算items之间的gap
    function getItemGap() {
      if (sliderItems.length < 2) return 0;
      
      // 获取第一个和第二个item的位置信息
      const firstRect = sliderItems[0].getBoundingClientRect();
      const secondRect = sliderItems[1].getBoundingClientRect();
      
      // 计算gap (第二个item的左边缘 - 第一个item的右边缘)
      return secondRect.left - (firstRect.left + firstRect.width);
    }
    
    // 添加点击事件
    navItems.forEach(navItem => {    
      navItem.addEventListener('click', function() {
        if (isAnimating) return;
        
        const clickedIndex = parseInt(this.getAttribute('data-index'));
        goToSlide(clickedIndex);
      });  
    });
    
    
    // 添加鼠标悬停暂停功能
    sliderWrapper.addEventListener('mouseenter', pauseSlider);
    sliderWrapper.addEventListener('mouseleave', resumeSlider);
    
    // 增强的触摸处理
    let touchStartX = 0;
    let touchEndX = 0;
    let touchMoveX = 0;
    let startScrollLeft = 0;
    let lastMoveTime = 0;
    let touchVelocity = 0;
    
    slidesContainer.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) return;
      
      isTouching = true;
      touchStartX = e.touches[0].clientX;
      startScrollLeft = slidesContainer.scrollLeft;
      lastMoveTime = Date.now();
      touchVelocity = 0;
      
      // 停止所有动画并暂停轮播
      slidesContainer.style.scrollBehavior = 'auto';
      pauseSlider();
      
      // 阻止默认行为可能导致页面无法滚动，仅在必要时使用
      // e.preventDefault();
    }, {passive: true});
    
    slidesContainer.addEventListener('touchmove', (e) => {
      if (!isTouching || e.touches.length !== 1) return;
      
      const currentX = e.touches[0].clientX;
      const diff = touchStartX - currentX;
      touchMoveX = currentX;
      
      // 计算速度 (像素/毫秒)
      const now = Date.now();
      const elapsed = now - lastMoveTime;
      if (elapsed > 0) {
        touchVelocity = (touchMoveX - touchStartX) / elapsed;
      }
      lastMoveTime = now;
      
      // 直接设置滚动位置以实现拖动效果
      slidesContainer.scrollLeft = startScrollLeft + diff;
      
      // 防止触发上层元素的滚动
      if (Math.abs(diff) > 5) {
        e.preventDefault();
      }
    }, {passive: false}); // 注意：需要设置为false才能使用preventDefault
    
    slidesContainer.addEventListener('touchend', (e) => {
      if (!isTouching) return;
      
      isTouching = false;
      touchEndX = touchMoveX || e.changedTouches[0].clientX;
      
      // 恢复平滑滚动
      slidesContainer.style.scrollBehavior = 'smooth';
      
      // 考虑速度来决定是否应该翻页
      const threshold = 50; // 滑动阈值
      const velocityThreshold = 0.5; // 速度阈值(像素/毫秒)
      const diffX = touchStartX - touchEndX;
      
      if (Math.abs(diffX) > threshold || Math.abs(touchVelocity) > velocityThreshold) {
        // 计算应该滚动到哪个项
        handleSwipe(diffX > 0);
      } else {
        // 回到当前项
        scrollToSlide(currentSlide);
      }
      
      // 延迟恢复自动播放
      clearTimeout(resumeTimeout);
      resumeTimeout = setTimeout(() => {
        resumeSlider();
      }, resumeDelay);
    }, {passive: true});
    
    // 优化的滑动处理
    function handleSwipe(isNext) {
      if (isNext) {
        // 向左滑动 - 下一张
        const next = (currentSlide + 1) % sliderItems.length;
        goToSlide(next);
      } else {
        // 向右滑动 - 上一张
        const prev = (currentSlide - 1 + sliderItems.length) % sliderItems.length;
        goToSlide(prev);
      }
    }
    
    // 监听滚动事件，同步导航状态 - 减少调用频率
    let scrollTimeout = null;
    slidesContainer.addEventListener('scroll', function() {
      if (isAnimating || isTouching) return;
      
      // 防抖动处理
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const newIndex = getCurrentSlideIndex();
        
        if (newIndex !== currentSlide && newIndex >= 0 && newIndex < sliderItems.length) {
          goToSlide(newIndex);
        }
      }, 150);
    }, {passive: true});
    
    // 计算当前应该显示哪个幻灯片
    function getCurrentSlideIndex() {
      // 计算单个项目的总宽度（包括间隙）
      const itemWidth = sliderItems[0].offsetWidth;
      const totalItemWidth = itemWidth + itemGap;
      
      // 计算当前索引，考虑gap
      const scrollPosition = slidesContainer.scrollLeft;
      return Math.round(scrollPosition / totalItemWidth);
    }
    
    // 处理窗口大小变化
    let resizeTimer = null;
    window.addEventListener('resize', function() {
      // 防抖动处理
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        // 重新计算gap
        const newGap = getItemGap();
        if (newGap !== itemGap) {
          itemGap = newGap;
        }
        
        // 重新滚动到当前项
        scrollToSlide(currentSlide);
      }, 250);
    });
    
    // 当轮播不在可视区域时暂停
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        if (!autoPlayTimer && !isTouching) {
          // 恢复前面已完成的导航状态
          updateNavStatus(currentSlide);
          resumeSlider();
        }
      } else {
        pauseSlider();
      }
    }, { threshold: 0.5 });
    
    observer.observe(section);

    // 初始化轮播
    startAutoPlay();

    
    // 暂停轮播的函数
    function pauseSlider() {
      // 保存当前进度值，以便恢复时继续
      savedProgressValue = progressValue;
      
      // 清除所有定时器
      clearInterval(autoPlayTimer);
      clearInterval(progressTimer);
      autoPlayTimer = null;
      progressTimer = null;
    }
    
    // 恢复轮播的函数
    function resumeSlider() {
      // 如果已经在运行或正在触摸，不重复启动
      if (autoPlayTimer || progressTimer || isTouching) return;
      
      // 恢复进度值
      progressValue = savedProgressValue;
      
      // 重新启动进度条更新
      progressTimer = setInterval(updateProgress, progressUpdateInterval);
    }
    
    // 标记当前活动的导航和轮播项
    function setActiveSlide(index) {
      // 移除所有活动状态
      sliderItems.forEach(item => {
        item.classList.remove('slider-nav_active');
      });
      
      // 设置新的活动项
      sliderItems[index].classList.add('slider-nav_active');
      
      // 滚动到当前项
      scrollToSlide(index);
    }
    
    // 平滑滚动到指定幻灯片
    function scrollToSlide(index) {
      // 计算单个项的总宽度（包括gap）
      const itemWidth = sliderItems[0].offsetWidth;
      const scrollPosition = index * (itemWidth + itemGap);
      
      // 使用平滑滚动
      slidesContainer.style.scrollBehavior = 'smooth';
      slidesContainer.scrollLeft = scrollPosition;
      
      // 300ms后恢复自动模式，以便支持touchmove
      setTimeout(() => {
        if (!isTouching) {
          slidesContainer.style.scrollBehavior = 'auto';
        }
      }, 300);
    }
    
    // 初始化进度条
    function resetAllProgress() {
      navItems.forEach(item => {
        item.classList.remove('completed', 'slider-nav_active');
        const progressBar = item.querySelector('.joe-slider-nav_progress');
        if (progressBar) {
          progressBar.style.width = '0%';
        }
      });
    }
    
    // 更新导航项状态 - 前面填满，后面清空
    function updateNavStatus(currentIndex) {
      navItems.forEach((item, index) => {
        const progressBar = item.querySelector('.joe-slider-nav_progress');
        if (!progressBar) return;
        
        if (index < currentIndex) {
          // 当前项之前的导航项 - 填满
          item.classList.add('completed');
          progressBar.style.width = '100%';
        } else if (index > currentIndex) {
          // 当前项之后的导航项 - 清空
          item.classList.remove('completed', 'slider-nav_active');
          progressBar.style.width = '0%';
        }
        // 当前项的状态在updateProgress中处理
      });
    }
    
    // 更新当前幻灯片进度
    function updateProgress() {
      progressValue += (progressUpdateInterval / slideTime) * 100;
      
      const currentNavItem = navItems[currentSlide];
      const progressBar = currentNavItem.querySelector('.joe-slider-nav_progress');
      
      if (progressValue >= 100) {
        progressValue = 100;
        
        // 标记当前导航项为已完成
        currentNavItem.classList.add('completed');
        if (progressBar) {
          progressBar.style.width = '100%';
        }
        
        clearInterval(progressTimer);
        progressTimer = null;
        
        // 自动切换到下一张
        setTimeout(() => {
          nextSlide();
        }, 50);
        return;
      }
      
      // 更新进度条宽度
      if (progressBar) {
        progressBar.style.width = progressValue + '%';
      }
    }
    
    // 切换到指定幻灯片
    function goToSlide(index) {
      // 防止正在动画时重复触发
      if (isAnimating) return;
      isAnimating = true;
      
      // 清除定时器和恢复计时器
      clearInterval(autoPlayTimer);
      clearInterval(progressTimer);
      clearTimeout(resumeTimeout);
      autoPlayTimer = null;
      progressTimer = null;
      
      // 检查是否需要重置（回到第一张）
      if (index === 0 && currentSlide === sliderItems.length - 1) {
        resetAllProgress();
      } else {
        // 更新导航项状态 - 前面填满，后面清空
        updateNavStatus(index);
      }
      
      // 标记当前导航项为活动
      navItems.forEach(item => item.classList.remove('slider-nav_active'));
      navItems[index].classList.add('slider-nav_active');
      
      // 更新当前幻灯片
      currentSlide = index;
      setActiveSlide(currentSlide);
      
      // 重置当前项的进度值
      progressValue = 0;
      savedProgressValue = 0;
      const currentProgressBar = navItems[index].querySelector('.joe-slider-nav_progress');
      if (currentProgressBar) {
        currentProgressBar.style.width = '0%';
      }
      navItems[index].classList.remove('completed');
      
      // 启动进度条更新
      progressTimer = setInterval(updateProgress, progressUpdateInterval);
      
      // 动画完成后解锁
      setTimeout(() => {
        isAnimating = false;
      }, 500);
    }
    
    // 切换到下一张幻灯片
    function nextSlide() {
      const next = (currentSlide + 1) % sliderItems.length;
      goToSlide(next);
    }
    
    // 开始自动轮播
    function startAutoPlay() {
      resetAllProgress();
      goToSlide(0);
    }
    
  }
});